// extracted by mini-css-extract-plugin
export default {"navLink":"Mb","blinking":"Nb"};